/**
 * Reglas de la selección masiva de la matriz de roles (caso 3).
 *
 * WHY vive fuera del componente: es la única pieza donde una equivocación se
 * paga con un 403 opaco. `sp_role_set_permissions` valida el conjunto ENTERO al
 * guardar —no el cambio—, así que basta con que una selección masiva marque un
 * permiso que el editor no posee para que el guardado falle con «No puede
 * otorgar N permiso(s) que usted no tiene», sin decir cuál de las cien casillas
 * lo provocó. Aquí se puede probar sin montar React.
 */

/** Formato de clave que usa el backend en `ungrantable`. */
export const clavePermiso = (p) => `${p.module}:${p.action}`;

/**
 * Permisos que una selección masiva puede tocar: existen en el catálogo y no
 * los bloquea la regla de no-escalada (H12).
 *
 * La regla en una frase: lo masivo hace exactamente lo que harían los clics uno
 * a uno. Ni marca lo que está deshabilitado, ni lo desmarca.
 */
export const seleccionablesDe = (catalog, ungrantableSet) =>
  (catalog ?? []).filter((p) => !ungrantableSet.has(clavePermiso(p)));

/** Agrupa ids de permiso por `action` (columnas) o `module` (filas). */
export const agruparIds = (lista, campo) => {
  const mapa = new Map();
  (lista ?? []).forEach((p) => {
    if (!mapa.has(p[campo])) mapa.set(p[campo], []);
    mapa.get(p[campo]).push(p.id);
  });
  return mapa;
};

/**
 * Aplica el marcado o desmarcado masivo sobre la selección actual.
 *
 * Devuelve un conjunto nuevo: React compara por identidad y mutar el anterior
 * dejaría la tabla sin repintar.
 */
export const aplicarMasivoA = (previo, ids, marcar) => {
  const next = new Set(previo);
  ids.forEach((id) => (marcar ? next.add(id) : next.delete(id)));
  return next;
};
